// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════
   AddonModal.css  |  Full-height two-column panel
   ═══════════════════════════════════════════════════════ */

/* ── Overlay backdrop ── */
.am-overlay {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.35);
}

/* ── Main container: sits on the right, full height ── */
.am-container {
  display: flex;
  flex-direction: row;
  width: 80vw;
  height: 100%;
  background: transparent;
  overflow: hidden;
}

/* ══ LEFT COLUMN ══ */
.am-left {
  width: 320px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.am-left::-webkit-scrollbar { width: 3px; }
.am-left::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* Image */
.am-image-wrap {
  width: 100%;
  height: 280px;
  flex-shrink: 0;
  overflow: hidden;
  background: #e8edf5;
  position: relative;
}

.am-product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.am-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #edf0f5;
}

.am-left-meta {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 14px 12px;
  background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 100%);
}

.am-meta-top-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.am-product-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

.am-shortcode-badge {
  background: rgba(220, 38, 38, 0.85);
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
}

.am-product-price {
  font-size: 1.4rem;
  font-weight: 800;
  color: #fff;
  margin: 0;
}

/* ── Pricing section ── */
.am-pricing-section {
  padding: 16px 14px;
  flex: 1;
}

.am-pricing-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.am-pricing-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1f2937;
}

.am-pricing-hint {
  font-size: 0.7rem;
  font-weight: 600;
  color: #9ca3af;
}

.am-pricing-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: #fff;
}

.am-pricing-option:hover { border-color: #93c5fd; background: #f8faff; }
.am-pricing-option--active { border-color: #3b82f6; background: #eff6ff; }
.am-pricing-option--active .am-option-label { color: #1d4ed8; font-weight: 700; }

.am-pricing-option--disabled {
  opacity: 0.6;
  background: #fafafa;
  border-color: #e5e7eb;
  cursor: not-allowed;
}
.am-pricing-option--disabled:hover {
  border-color: #e5e7eb;
  background: #fafafa;
}
.am-pricing-option--disabled .am-option-label {
  color: #9ca3af;
}

.am-option-label {
  font-size: 0.84rem;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.am-radio {
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  accent-color: #3b82f6;
  cursor: pointer;
}

.am-discount-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  padding: 8px 12px;
  background: #f0f6ff;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
}

.am-discount-type-btn {
  width: 30px;
  height: 30px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.am-discount-type-btn.active { border-color: #3b82f6; background: #3b82f6; color: #fff; }

.am-discount-input {
  flex: 1;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 0.8rem;
  color: #1f2937;
  outline: none;
  background: #fff;
  font-family: inherit;
  transition: border-color 0.15s;
  -moz-appearance: textfield;
}

.am-discount-input::-webkit-outer-spin-button,
.am-discount-input::-webkit-inner-spin-button { -webkit-appearance: none; }
.am-discount-input:focus { border-color: #3b82f6; }

/* ══ RIGHT COLUMN ══ */
.am-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  overflow: hidden;
  position: relative;
}

/* Close button — absolute top right */
.am-close-btn {
  position: absolute;
  top: 12px;
  right: 14px;
  z-index: 2;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: background 0.15s;
  flex-shrink: 0;
}

.am-close-btn:hover { background: #f3f4f6; }

/* Scrollable body */
.am-right-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 16px 8px;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.am-right-body::-webkit-scrollbar { width: 4px; }
.am-right-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* ── Section ── */
.am-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
}

.am-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.am-section-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1f2937;
}

/* ── Badges ── */
.am-badge {
  font-size: 0.65rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
}

.am-badge-required { background: #fee2e2; color: #dc2626; }
.am-badge-optional { background: #f3f4f6; color: #6b7280; }

/* ── Variant Grid — 3 per row ── */
.am-variant-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.am-variant-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
  gap: 6px;
}

.am-variant-card:hover:not(.am-variant-oos) { border-color: #93c5fd; background: #f8faff; }
.am-variant-selected { border-color: #3b82f6; background: #eff6ff; }
.am-variant-oos { opacity: 0.45; cursor: not-allowed; }

.am-variant-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }

.am-variant-name { font-size: 0.8rem; font-weight: 700; color: #1f2937; line-height: 1.2; }
.am-variant-selected .am-variant-name { color: #1d4ed8; }

.am-variant-price { font-size: 0.72rem; font-weight: 600; color: #6b7280; }
.am-variant-selected .am-variant-price { color: #3b82f6; }

.am-variant-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;
}

.am-variant-radio--selected { border-color: #3b82f6; background: #3b82f6; }
.am-variant-radio-dot { width: 7px; height: 7px; border-radius: 50%; background: #fff; }
.am-nav-focused.am-variant-card { outline: 2px solid #3b82f6; outline-offset: 1px; }

/* ── Addon Group ── */
.am-group { margin-bottom: 16px; }
.am-group:last-child { margin-bottom: 0; }

.am-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.am-group-name { font-size: 0.82rem; font-weight: 700; color: #374151; }
.am-group-max { font-size: 0.68rem; font-weight: 600; color: #9ca3af; }
.am-group-max--reached { color: #f97316; }

/* ── Addon list: 2-column row layout ── */
.am-addon-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.am-addon-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #f0f2f5;
}

.am-addon-row:last-child { border-bottom: none; }

.am-addon-cell {
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.12s;
  position: relative;
  border-right: 1px solid #f0f2f5;
  background: #fff;
}

.am-addon-cell:last-child { border-right: none; }
.am-addon-cell--empty { background: #fafafa; cursor: default; }

.am-addon-cell:hover:not(.am-addon-cell--unavailable):not(.am-addon-cell--max):not(.am-addon-cell--empty) {
  background: #f8faff;
}

.am-addon-cell--selected { background: #eff6ff; border-left: 3px solid #3b82f6; }
.am-addon-cell--unavailable { opacity: 0.55; cursor: not-allowed; background: #fafafa; }
.am-addon-cell--max:not(.am-addon-cell--selected) { opacity: 0.5; cursor: not-allowed; }
.am-nav-focused.am-addon-cell { outline: 2px solid #3b82f6; outline-offset: -2px; }

.am-addon-cell-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
}

.am-addon-cell-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: #1f2937;
  flex: 1;
  line-height: 1.3;
}

.am-addon-cell--selected .am-addon-cell-name { color: #1d4ed8; font-weight: 600; }

.am-addon-cell-price {
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

/* Status tags */
.am-addon-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.64rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  margin-top: 4px;
}

.am-addon-status-tag--oos { background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; }
.am-addon-status-tag--ns { background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; }

/* Qty controls inside cell */
.am-addon-ctrl {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.am-addon-ctrl-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #2563eb;
  background: #fff;
  color: #2563eb;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s;
  flex-shrink: 0;
}

.am-addon-ctrl-btn:not(.am-addon-ctrl-btn--disabled):hover:not(:disabled) { background: #2563eb; color: #fff; }
.am-addon-ctrl-btn--disabled, .am-addon-ctrl-btn:disabled { 
  border-color: #e5e7eb; 
  color: #9ca3af; 
  background-color: #f3f4f6;
  cursor: not-allowed; 
}

.am-addon-ctrl-qty {
  font-size: 0.8rem;
  font-weight: 700;
  color: #1f2937;
  min-width: 14px;
  text-align: center;
}

/* ── Notes textarea ── */
.am-notes {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.82rem;
  font-family: inherit;
  color: #1f2937;
  resize: none;
  outline: none;
  background: #fff;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.am-notes:focus { border-color: #3b82f6; }
.am-notes::placeholder { color: #9ca3af; }

/* ── Loader / Empty ── */
.am-loader { display: flex; align-items: center; justify-content: center; padding: 16px 0; }
.am-empty { font-size: 0.78rem; color: #9ca3af; text-align: center; padding: 14px 0; }

/* ══ FOOTER ══ */
.am-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.am-total-block { flex: 1; display: flex; flex-direction: column; }

.am-total-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 1px;
}

.am-total-amount {
  font-size: 1.2rem;
  font-weight: 800;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 6px;
}

.am-total-strike { font-size: 0.85rem; font-weight: 600; color: #9ca3af; text-decoration: line-through; }
.am-total-free { color: #7c3aed; font-size: 1.2rem; font-weight: 800; }

.am-footer-actions { display: flex; align-items: center; gap: 10px; }

.am-qty-selector {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e6ea;
  border-radius: 999px;
  overflow: hidden;
  background: #fff;
}

.am-qty-btn {
  width: 34px;
  height: 38px;
  border: none;
  font-size: 1.1rem;
  font-weight: 700;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.12s;
  background: transparent;
}

.am-qty-btn:hover:not(:disabled) { background: #e8edf5; }
.am-qty-btn:disabled { opacity: 0.38; cursor: not-allowed; }

.am-qty-value {
  min-width: 34px;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 800;
  color: #1f2937;
  line-height: 38px;
  padding: 0 4px;
}

.am-add-btn {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0 28px;
  height: 42px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.28);
  transition: background 0.15s, box-shadow 0.15s, transform 0.1s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.am-add-btn:hover { background: #1d4ed8; box-shadow: 0 4px 14px rgba(37, 99, 235, 0.38); }
.am-add-btn:active { transform: scale(0.97); }
.am-add-btn:disabled { background: #93c5fd; cursor: not-allowed; box-shadow: none; }

/* ═══ DARK THEME — AddonModal ═══ */
.dark .am-left {
  background: #1e293b;
  scrollbar-color: #334155 transparent;
}
.dark .am-image-placeholder { background: #243043; }

.dark .am-pricing-title { color: #e2e8f0; }
.dark .am-pricing-hint { color: #64748b; }

.dark .am-pricing-option {
  background: #0f172a;
  border-color: #334155;
}
.dark .am-pricing-option:hover { border-color: #3b82f6; background: #1e293b; }
.dark .am-pricing-option--active { border-color: #3b82f6; background: rgba(59,130,246,0.12); }
.dark .am-pricing-option--disabled { background: #1e293b; border-color: #334155; }
.dark .am-option-label { color: #e2e8f0; }

.dark .am-discount-row {
  background: #172554;
  border-color: #1d4ed8;
}
.dark .am-discount-type-btn {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .am-discount-input {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .am-discount-input:focus { border-color: #3b82f6; }

.dark .am-right { background: #0f172a; }
.dark .am-close-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .am-close-btn:hover { background: #334155; }

.dark .am-section {
  background: #1e293b;
  border-color: #334155;
}
.dark .am-section-title { color: #e2e8f0; }

.dark .am-badge-optional { background: #1e293b; color: #64748b; }

.dark .am-variant-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .am-variant-card:hover:not(.am-variant-oos) { border-color: #3b82f6; background: #243043; }
.dark .am-variant-selected { border-color: #3b82f6; background: rgba(59,130,246,0.1); }
.dark .am-variant-name { color: #e2e8f0; }
.dark .am-variant-price { color: #94a3b8; }

.dark .am-addon-list { border-color: #334155; }
.dark .am-addon-row { border-bottom-color: #334155; }
.dark .am-addon-cell {
  background: #1e293b;
  border-right-color: #334155;
}
.dark .am-addon-cell--empty { background: #0f172a; }
.dark .am-addon-cell:hover:not(.am-addon-cell--unavailable):not(.am-addon-cell--max):not(.am-addon-cell--empty) {
  background: #243043;
}
.dark .am-addon-cell--selected { background: rgba(59,130,246,0.1); border-left-color: #3b82f6; }
.dark .am-addon-cell-name { color: #e2e8f0; }
.dark .am-addon-cell-price { color: #cbd5e1; }

.dark .am-addon-ctrl-btn {
  background: #1e293b;
}
.dark .am-addon-ctrl-btn--disabled,
.dark .am-addon-ctrl-btn:disabled {
  background-color: #0f172a;
  border-color: #334155;
  color: #475569;
}
.dark .am-addon-ctrl-qty { color: #e2e8f0; }

.dark .am-notes {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .am-notes:focus { border-color: #3b82f6; }
.dark .am-notes::placeholder { color: #475569; }

.dark .am-footer {
  background: #1e293b;
  border-top-color: #334155;
}
.dark .am-total-label { color: #64748b; }
.dark .am-total-amount { color: #f1f5f9; }
.dark .am-total-strike { color: #64748b; }

.dark .am-qty-selector {
  background: #1e293b;
  border-color: #334155;
}
.dark .am-qty-btn { color: #94a3b8; }
.dark .am-qty-btn:hover:not(:disabled) { background: #334155; }
.dark .am-qty-value { color: #f1f5f9; }

.dark .am-group-name { color: #e2e8f0; }
.dark .am-group-max  { color: #64748b; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/AddonModal/AddonModal.css"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE7E,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA,2BAA2B,qBAAqB,EAAE,mBAAmB,EAAE;AACvE,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE;AACzE,8CAA8C,cAAc,EAAE,gBAAgB,EAAE;;AAEhF;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+BAA+B,qBAAqB,EAAE,mBAAmB,EAAE,WAAW,EAAE;;AAExF;EACE,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;gDACgD,wBAAwB,EAAE;AAC1E,2BAA2B,qBAAqB,EAAE;;AAElD,uBAAuB;AACvB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE;;AAE3C,oBAAoB;AACpB;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,oCAAoC,UAAU,EAAE;AAChD,0CAA0C,mBAAmB,EAAE,kBAAkB,EAAE;;AAEnF,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,mCAAmC;AACnC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,QAAQ;AACV;;AAEA,8CAA8C,qBAAqB,EAAE,mBAAmB,EAAE;AAC1F,uBAAuB,qBAAqB,EAAE,mBAAmB,EAAE;AACnE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE;;AAEtD,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,OAAO,EAAE;;AAE7E,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1F,wCAAwC,cAAc,EAAE;;AAExD,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1E,yCAAyC,cAAc,EAAE;;AAEzD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;AAC1E,wBAAwB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACvF,kCAAkC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEnF,sBAAsB;AACtB,YAAY,mBAAmB,EAAE;AACjC,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,yBAAyB,cAAc,EAAE;;AAEzC,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,4BAA4B,kBAAkB,EAAE;AAChD,wBAAwB,mBAAmB,EAAE,eAAe,EAAE;;AAE9D;EACE,mBAAmB;AACrB;;AAEA,2BAA2B,mBAAmB,EAAE,8BAA8B,EAAE;AAChF,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACvF,oDAAoD,YAAY,EAAE,mBAAmB,EAAE;AACvF,gCAAgC,0BAA0B,EAAE,oBAAoB,EAAE;;AAElF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;;AAEA,+CAA+C,cAAc,EAAE,gBAAgB,EAAE;;AAEjF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4BAA4B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC5F,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE3F,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,4EAA4E,mBAAmB,EAAE,WAAW,EAAE;AAC9G;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,kBAAkB,qBAAqB,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC,yBAAyB;AACzB,aAAa,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE;AAC3F,YAAY,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAErF,iBAAiB;AACjB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,kBAAkB,OAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAElE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACxG,iBAAiB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEtE,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;;AAE3D;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,oBAAoB,mBAAmB,EAAE,8CAA8C,EAAE;AACzF,qBAAqB,sBAAsB,EAAE;AAC7C,uBAAuB,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEnF,oCAAoC;AACpC;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD,0BAA0B,cAAc,EAAE;AAC1C,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,iCAAiC,qBAAqB,EAAE,mBAAmB,EAAE;AAC7E,mCAAmC,qBAAqB,EAAE,iCAAiC,EAAE;AAC7F,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE;AACjF,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,iCAAiC,qBAAqB,EAAE;;AAExD,kBAAkB,mBAAmB,EAAE;AACvC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,0BAA0B,cAAc,EAAE;;AAE1C,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,oDAAoD,qBAAqB,EAAE,mBAAmB,EAAE;AAChG,6BAA6B,qBAAqB,EAAE,gCAAgC,EAAE;AACtF,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,cAAc,EAAE;;AAE1C,uBAAuB,qBAAqB,EAAE;AAC9C,sBAAsB,4BAA4B,EAAE;AACpD;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,mBAAmB;AACrB;AACA,iCAAiC,gCAAgC,EAAE,0BAA0B,EAAE;AAC/F,4BAA4B,cAAc,EAAE;AAC5C,6BAA6B,cAAc,EAAE;;AAE7C;EACE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,wBAAwB,qBAAqB,EAAE;AAC/C,+BAA+B,cAAc,EAAE;;AAE/C;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,wBAAwB,cAAc,EAAE;AACxC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,oBAAoB,cAAc,EAAE;AACpC,yCAAyC,mBAAmB,EAAE;AAC9D,sBAAsB,cAAc,EAAE;;AAEtC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════\n   AddonModal.css  |  Full-height two-column panel\n   ═══════════════════════════════════════════════════════ */\n\n/* ── Overlay backdrop ── */\n.am-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n/* ── Main container: sits on the right, full height ── */\n.am-container {\n  display: flex;\n  flex-direction: row;\n  width: 80vw;\n  height: 100%;\n  background: transparent;\n  overflow: hidden;\n}\n\n/* ══ LEFT COLUMN ══ */\n.am-left {\n  width: 320px;\n  min-width: 320px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.am-left::-webkit-scrollbar { width: 3px; }\n.am-left::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* Image */\n.am-image-wrap {\n  width: 100%;\n  height: 280px;\n  flex-shrink: 0;\n  overflow: hidden;\n  background: #e8edf5;\n  position: relative;\n}\n\n.am-product-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.am-image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #edf0f5;\n}\n\n.am-left-meta {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 32px 14px 12px;\n  background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 100%);\n}\n\n.am-meta-top-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.am-product-name {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.2;\n}\n\n.am-shortcode-badge {\n  background: rgba(220, 38, 38, 0.85);\n  color: #fff;\n  font-size: 0.6rem;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.am-product-price {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: #fff;\n  margin: 0;\n}\n\n/* ── Pricing section ── */\n.am-pricing-section {\n  padding: 16px 14px;\n  flex: 1;\n}\n\n.am-pricing-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.am-pricing-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.am-pricing-hint {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #9ca3af;\n}\n\n.am-pricing-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  background: #fff;\n}\n\n.am-pricing-option:hover { border-color: #93c5fd; background: #f8faff; }\n.am-pricing-option--active { border-color: #3b82f6; background: #eff6ff; }\n.am-pricing-option--active .am-option-label { color: #1d4ed8; font-weight: 700; }\n\n.am-pricing-option--disabled {\n  opacity: 0.6;\n  background: #fafafa;\n  border-color: #e5e7eb;\n  cursor: not-allowed;\n}\n.am-pricing-option--disabled:hover {\n  border-color: #e5e7eb;\n  background: #fafafa;\n}\n.am-pricing-option--disabled .am-option-label {\n  color: #9ca3af;\n}\n\n.am-option-label {\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #1f2937;\n  flex: 1;\n}\n\n.am-radio {\n  flex-shrink: 0;\n  width: 17px;\n  height: 17px;\n  accent-color: #3b82f6;\n  cursor: pointer;\n}\n\n.am-discount-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 8px;\n  padding: 8px 12px;\n  background: #f0f6ff;\n  border-radius: 8px;\n  border: 1px solid #bfdbfe;\n}\n\n.am-discount-type-btn {\n  width: 30px;\n  height: 30px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #374151;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.am-discount-type-btn.active { border-color: #3b82f6; background: #3b82f6; color: #fff; }\n\n.am-discount-input {\n  flex: 1;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  padding: 5px 8px;\n  font-size: 0.8rem;\n  color: #1f2937;\n  outline: none;\n  background: #fff;\n  font-family: inherit;\n  transition: border-color 0.15s;\n  -moz-appearance: textfield;\n}\n\n.am-discount-input::-webkit-outer-spin-button,\n.am-discount-input::-webkit-inner-spin-button { -webkit-appearance: none; }\n.am-discount-input:focus { border-color: #3b82f6; }\n\n/* ══ RIGHT COLUMN ══ */\n.am-right {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #f7f8fa;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Close button — absolute top right */\n.am-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  z-index: 2;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #6b7280;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.am-close-btn:hover { background: #f3f4f6; }\n\n/* Scrollable body */\n.am-right-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 16px 8px;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.am-right-body::-webkit-scrollbar { width: 4px; }\n.am-right-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* ── Section ── */\n.am-section {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.am-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.am-section-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n/* ── Badges ── */\n.am-badge {\n  font-size: 0.65rem;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 20px;\n}\n\n.am-badge-required { background: #fee2e2; color: #dc2626; }\n.am-badge-optional { background: #f3f4f6; color: #6b7280; }\n\n/* ── Variant Grid — 3 per row ── */\n.am-variant-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.am-variant-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.15s;\n  gap: 6px;\n}\n\n.am-variant-card:hover:not(.am-variant-oos) { border-color: #93c5fd; background: #f8faff; }\n.am-variant-selected { border-color: #3b82f6; background: #eff6ff; }\n.am-variant-oos { opacity: 0.45; cursor: not-allowed; }\n\n.am-variant-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }\n\n.am-variant-name { font-size: 0.8rem; font-weight: 700; color: #1f2937; line-height: 1.2; }\n.am-variant-selected .am-variant-name { color: #1d4ed8; }\n\n.am-variant-price { font-size: 0.72rem; font-weight: 600; color: #6b7280; }\n.am-variant-selected .am-variant-price { color: #3b82f6; }\n\n.am-variant-radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #d1d5db;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.15s;\n}\n\n.am-variant-radio--selected { border-color: #3b82f6; background: #3b82f6; }\n.am-variant-radio-dot { width: 7px; height: 7px; border-radius: 50%; background: #fff; }\n.am-nav-focused.am-variant-card { outline: 2px solid #3b82f6; outline-offset: 1px; }\n\n/* ── Addon Group ── */\n.am-group { margin-bottom: 16px; }\n.am-group:last-child { margin-bottom: 0; }\n\n.am-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.am-group-name { font-size: 0.82rem; font-weight: 700; color: #374151; }\n.am-group-max { font-size: 0.68rem; font-weight: 600; color: #9ca3af; }\n.am-group-max--reached { color: #f97316; }\n\n/* ── Addon list: 2-column row layout ── */\n.am-addon-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.am-addon-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-bottom: 1px solid #f0f2f5;\n}\n\n.am-addon-row:last-child { border-bottom: none; }\n\n.am-addon-cell {\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: background 0.12s;\n  position: relative;\n  border-right: 1px solid #f0f2f5;\n  background: #fff;\n}\n\n.am-addon-cell:last-child { border-right: none; }\n.am-addon-cell--empty { background: #fafafa; cursor: default; }\n\n.am-addon-cell:hover:not(.am-addon-cell--unavailable):not(.am-addon-cell--max):not(.am-addon-cell--empty) {\n  background: #f8faff;\n}\n\n.am-addon-cell--selected { background: #eff6ff; border-left: 3px solid #3b82f6; }\n.am-addon-cell--unavailable { opacity: 0.55; cursor: not-allowed; background: #fafafa; }\n.am-addon-cell--max:not(.am-addon-cell--selected) { opacity: 0.5; cursor: not-allowed; }\n.am-nav-focused.am-addon-cell { outline: 2px solid #3b82f6; outline-offset: -2px; }\n\n.am-addon-cell-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.am-addon-cell-name {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #1f2937;\n  flex: 1;\n  line-height: 1.3;\n}\n\n.am-addon-cell--selected .am-addon-cell-name { color: #1d4ed8; font-weight: 600; }\n\n.am-addon-cell-price {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n}\n\n/* Status tags */\n.am-addon-status-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.64rem;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n.am-addon-status-tag--oos { background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; }\n.am-addon-status-tag--ns { background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; }\n\n/* Qty controls inside cell */\n.am-addon-ctrl {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.am-addon-ctrl-btn {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1.5px solid #2563eb;\n  background: #fff;\n  color: #2563eb;\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.12s;\n  flex-shrink: 0;\n}\n\n.am-addon-ctrl-btn:not(.am-addon-ctrl-btn--disabled):hover:not(:disabled) { background: #2563eb; color: #fff; }\n.am-addon-ctrl-btn--disabled, .am-addon-ctrl-btn:disabled { \n  border-color: #e5e7eb; \n  color: #9ca3af; \n  background-color: #f3f4f6;\n  cursor: not-allowed; \n}\n\n.am-addon-ctrl-qty {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #1f2937;\n  min-width: 14px;\n  text-align: center;\n}\n\n/* ── Notes textarea ── */\n.am-notes {\n  width: 100%;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 0.82rem;\n  font-family: inherit;\n  color: #1f2937;\n  resize: none;\n  outline: none;\n  background: #fff;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.am-notes:focus { border-color: #3b82f6; }\n.am-notes::placeholder { color: #9ca3af; }\n\n/* ── Loader / Empty ── */\n.am-loader { display: flex; align-items: center; justify-content: center; padding: 16px 0; }\n.am-empty { font-size: 0.78rem; color: #9ca3af; text-align: center; padding: 14px 0; }\n\n/* ══ FOOTER ══ */\n.am-footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  border-top: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.am-total-block { flex: 1; display: flex; flex-direction: column; }\n\n.am-total-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 1px;\n}\n\n.am-total-amount {\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.am-total-strike { font-size: 0.85rem; font-weight: 600; color: #9ca3af; text-decoration: line-through; }\n.am-total-free { color: #7c3aed; font-size: 1.2rem; font-weight: 800; }\n\n.am-footer-actions { display: flex; align-items: center; gap: 10px; }\n\n.am-qty-selector {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid #e2e6ea;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.am-qty-btn {\n  width: 34px;\n  height: 38px;\n  border: none;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.12s;\n  background: transparent;\n}\n\n.am-qty-btn:hover:not(:disabled) { background: #e8edf5; }\n.am-qty-btn:disabled { opacity: 0.38; cursor: not-allowed; }\n\n.am-qty-value {\n  min-width: 34px;\n  text-align: center;\n  font-size: 0.9rem;\n  font-weight: 800;\n  color: #1f2937;\n  line-height: 38px;\n  padding: 0 4px;\n}\n\n.am-add-btn {\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 0 28px;\n  height: 42px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: inherit;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.28);\n  transition: background 0.15s, box-shadow 0.15s, transform 0.1s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.am-add-btn:hover { background: #1d4ed8; box-shadow: 0 4px 14px rgba(37, 99, 235, 0.38); }\n.am-add-btn:active { transform: scale(0.97); }\n.am-add-btn:disabled { background: #93c5fd; cursor: not-allowed; box-shadow: none; }\n\n/* ═══ DARK THEME — AddonModal ═══ */\n.dark .am-left {\n  background: #1e293b;\n  scrollbar-color: #334155 transparent;\n}\n.dark .am-image-placeholder { background: #243043; }\n\n.dark .am-pricing-title { color: #e2e8f0; }\n.dark .am-pricing-hint { color: #64748b; }\n\n.dark .am-pricing-option {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .am-pricing-option:hover { border-color: #3b82f6; background: #1e293b; }\n.dark .am-pricing-option--active { border-color: #3b82f6; background: rgba(59,130,246,0.12); }\n.dark .am-pricing-option--disabled { background: #1e293b; border-color: #334155; }\n.dark .am-option-label { color: #e2e8f0; }\n\n.dark .am-discount-row {\n  background: #172554;\n  border-color: #1d4ed8;\n}\n.dark .am-discount-type-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .am-discount-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .am-discount-input:focus { border-color: #3b82f6; }\n\n.dark .am-right { background: #0f172a; }\n.dark .am-close-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .am-close-btn:hover { background: #334155; }\n\n.dark .am-section {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .am-section-title { color: #e2e8f0; }\n\n.dark .am-badge-optional { background: #1e293b; color: #64748b; }\n\n.dark .am-variant-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .am-variant-card:hover:not(.am-variant-oos) { border-color: #3b82f6; background: #243043; }\n.dark .am-variant-selected { border-color: #3b82f6; background: rgba(59,130,246,0.1); }\n.dark .am-variant-name { color: #e2e8f0; }\n.dark .am-variant-price { color: #94a3b8; }\n\n.dark .am-addon-list { border-color: #334155; }\n.dark .am-addon-row { border-bottom-color: #334155; }\n.dark .am-addon-cell {\n  background: #1e293b;\n  border-right-color: #334155;\n}\n.dark .am-addon-cell--empty { background: #0f172a; }\n.dark .am-addon-cell:hover:not(.am-addon-cell--unavailable):not(.am-addon-cell--max):not(.am-addon-cell--empty) {\n  background: #243043;\n}\n.dark .am-addon-cell--selected { background: rgba(59,130,246,0.1); border-left-color: #3b82f6; }\n.dark .am-addon-cell-name { color: #e2e8f0; }\n.dark .am-addon-cell-price { color: #cbd5e1; }\n\n.dark .am-addon-ctrl-btn {\n  background: #1e293b;\n}\n.dark .am-addon-ctrl-btn--disabled,\n.dark .am-addon-ctrl-btn:disabled {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #475569;\n}\n.dark .am-addon-ctrl-qty { color: #e2e8f0; }\n\n.dark .am-notes {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .am-notes:focus { border-color: #3b82f6; }\n.dark .am-notes::placeholder { color: #475569; }\n\n.dark .am-footer {\n  background: #1e293b;\n  border-top-color: #334155;\n}\n.dark .am-total-label { color: #64748b; }\n.dark .am-total-amount { color: #f1f5f9; }\n.dark .am-total-strike { color: #64748b; }\n\n.dark .am-qty-selector {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .am-qty-btn { color: #94a3b8; }\n.dark .am-qty-btn:hover:not(:disabled) { background: #334155; }\n.dark .am-qty-value { color: #f1f5f9; }\n\n.dark .am-group-name { color: #e2e8f0; }\n.dark .am-group-max  { color: #64748b; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
